import { MainHeader } from "./styled";

const Header = ({ title }) => (
    <MainHeader>{title}</MainHeader>
);

export default Header;